// extracted by mini-css-extract-plugin
module.exports = {"dropdownContainer":"Dropdown_dropdownContainer__1C6ex","placeholderContainer":"Dropdown_placeholderContainer__1yxuL"};